import { RuleResult } from '../../../../types/DeclarationP5'

interface C0933ValidatorParameters {
  security: string
  additionalDeclarationType: string
}

const validatePlaceOfRequirement = ({
  security,
  additionalDeclarationType,
}: C0933ValidatorParameters): RuleResult => {
  if (!['1', '3'].includes(security)) return 'NOT_ALLOWED'

  if (additionalDeclarationType === 'D') return 'OPTIONAL'

  return additionalDeclarationType === 'A' ? 'REQUIRED' : 'NOT_ALLOWED'
}

const C0933Validator = {
  validateHouseConsignmentPlaceOfAcceptanceRequirement: (
    formData: C0933ValidatorParameters,
  ): RuleResult => validatePlaceOfRequirement(formData),
  validateHouseConsignmentPlaceOfDeliveryRequirement: (
    formData: C0933ValidatorParameters,
  ): RuleResult => validatePlaceOfRequirement(formData),
}

export default C0933Validator
